<template>
  <div v-on:click="submittedSize()">
    <b-overlay
        :show="(loading || selectLoading)"
        rounded="sm"
        no-fade
      >

    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      :start-index.sync="activeIndex"
      layout="vertical"
      finish-button-text="Salvar"
      back-button-text="Voltar"
      next-button-text="Próximo"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >

      <!-- Detalhes -->
      <tab-content title="Detalhes">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Detalhes
            </h5>
            <small class="text-muted">
              Edite as principais informações da usina.
            </small>
          </b-col>

          <!-- alias -->
        <b-col cols="6">
          <b-form-group
            label="Alias"
            label-for="alias"
          >
            <b-form-input
              id="alias"
              :value="alias"
              placeholder="Alias"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- ID -->
        <b-col cols="6">
          <b-form-group
            label="ID"
            label-for="id"
          >
            <b-form-input
              id="id"
              :value="id"
              placeholder="ID"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- Nome -->
        <b-col cols="6">
          <b-form-group
            label="Nome"
            label-for="nome"
          >
            <b-form-input
              id="nome"
              v-model="nome"
              placeholder="Nome"
              :value="nome"
            />
          </b-form-group>
        </b-col>
        
        <!-- Grupo -->
        <b-col md="6">
          <b-form-group
            label="Grupo"
            label-for="v-grupo"
          >
            <v-select
              id="v-grupo"
              v-model="grupo_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="grupoName"
              label="text"
              placeholder="Selecione um Grupo"
            />
          </b-form-group>
        </b-col>

        </b-row>
      </tab-content>

      <!-- Descrição -->
      <tab-content title="Descrição">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Descrição
            </h5>
            <small class="text-muted">Edite a descrição da usina</small>
          </b-col>

          <b-col cols="12">
            <b-form-group
                    label="Descrição"
                    label-for="descricao"
                  >
              <b-form-textarea
                :value="descricao"
                id="descricao"
                v-model="descricao"
                placeholder="Digite aqui a descrição da usina"
                rows="5"
                :state="descricao.length <= maxChar"
                class="char-textarea"
                :class="descricao.length >= maxChar ? 'text-danger' : ''"/>
              <small
                class="textarea-counter-value float-right"
                :class="descricao.length >= maxChar ? 'bg-danger' : ''"
              >
                <span class="char-count">{{ descricao.length }}</span> / {{ maxChar }}
              </small>
          </b-form-group>
        </b-col>
          
        </b-row>
      </tab-content>

      <!-- Informações -->
      <tab-content title="Informações">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Informações
            </h5>
            <small class="text-muted">Edite as informações da usina.</small>
          </b-col>

          <!-- Site -->
          <b-col cols="6">
            <b-form-group
              label="Site"
              label-for="site"
            >
              <b-form-input
                id="site"
                v-model="site"
                placeholder="Site"
                :value="site"
              />
            </b-form-group>
          </b-col>

          <!-- E-mail -->
          <b-col cols="6">
            <b-form-group
              label="E-mail"
              label-for="email"
            >
              <b-form-input
                id="email"
                v-model="email"
                placeholder="E-mail"
                :value="email"
              />
            </b-form-group>
          </b-col>

          <!-- Telefone -->
          <b-col cols="4">
            <b-form-group
              label="Telefone"
              label-for="telefone"
            >
              <b-form-input
                id="telefone"
                v-model="telefone"
                placeholder="Telefone"
                :value="telefone"
              />
            </b-form-group>
          </b-col>

          <!-- CNPJ -->
          <b-col cols="4">
            <b-form-group
              label="CNPJ"
              label-for="cnpj"
            >
              <cleave
                id="cnpj"
                v-model="cnpj"
                class="form-control"
                placeholder="CNPJ"
                :raw="false"
                :value="cnpj"
                :options="options.cnpj"
              />
            </b-form-group>
          </b-col>

          <!-- Cooperativa -->
        <b-col md="4">
          <b-form-group
            label="Cooperativa"
            label-for="cooperativa"
          >
            <v-select
              id="cooperativa"
              v-model="cooperativa"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="cooperativaName"
              label="text"
              placeholder="Cooperativa"
            />
          </b-form-group>
        </b-col>

        </b-row>
      </tab-content>

      <!-- Endereço -->
      <tab-content title="Endereço">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Endereço
            </h5>
            <small class="text-muted">Edite o endereço da usina.</small>
          </b-col>

          <!-- Região -->
          <b-col cols="4">
            <b-form-group
              label="Região"
              label-for="regiao_id"
            >
              <v-select
                id="regiao_id"
                v-model="regiao_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="regiaoName"
                label="text"
                placeholder="Selecione uma Região"
              />
            </b-form-group>
          </b-col>

          <!-- Estado -->
          <b-col cols="4">
            <b-form-group
              label="Estado"
              label-for="estado_id"
            >
              <v-select
                id="estado_id"
                v-model="estado_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="estadoName"
                label="text"
                placeholder="Selecione um Estado"
              />
            </b-form-group>
          </b-col>

          <!-- Cidade -->
          <b-col cols="4">
            <b-form-group
              label="Cidade"
              label-for="cidade"
            >
              <b-form-input
                id="cidade"
                v-model="cidade"
                placeholder="Cidade"
                :value="cidade"
              />
            </b-form-group>
          </b-col>

          <!-- Endereço -->
          <b-col cols="12">
            <b-form-group
              label="Endereço"
              label-for="endereco"
            >
              <b-form-input
                id="endereco"
                v-model="endereco"
                placeholder="Endereço"
                :value="endereco"
              />
            </b-form-group>
          </b-col>

          <!-- CEP -->
          <b-col cols="6">
            <b-form-group
              label="CEP"
              label-for="cep"
            >
              <cleave
                id="cep"
                v-model="cep"
                class="form-control"
                placeholder="CEP"
                :raw="false"
                :value="cep"
                :options="options.cep"
              />
            </b-form-group>
          </b-col>

          <!-- Complemento -->
          <b-col cols="6">
            <b-form-group
              label="Complemento"
              label-for="complemento"
            >
              <b-form-input
                id="complemento"
                v-model="complemento"
                placeholder="Complemento"
                :value="complemento"
              />
            </b-form-group>
          </b-col>

        </b-row>
      </tab-content>

      <!-- Localização -->
      <tab-content title="Localização">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Localização
            </h5>
            <small class="text-muted">Edite a localização da usina.</small>
          </b-col>

          <!-- Maps -->
          <b-col cols="6">
            <l-map
              ref="mymap"
              :zoom="zoom"
              :center="center"
            >
              <l-tile-layer :url="url" />
              <l-marker :lat-lng="markerLatLng">
                <l-popup>Você está aqui!</l-popup>
              </l-marker>
            </l-map>
          </b-col>

          <b-col cols="6">
            <b-col cols="12">
              <b-form-group
              label="Latitude"
              label-for="latitude"
            >
              <b-form-input
                id="latitude"
                v-model="latitude"
                @input="changeLocation()"
                placeholder="Latitude"
                :value="latitude"
              />
            </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
              label="Longitude"
              label-for="longitude"
            >
              <b-form-input
                id="longitude"
                v-model="longitude"
                placeholder="Longitude"
                :value="longitude"
              />
            </b-form-group>
            </b-col>
          </b-col>


        </b-row>
      </tab-content>

    </form-wizard>
  </b-overlay>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BFormFile,
  BOverlay
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt';
import vSelect from 'vue-select';
import Cleave from 'vue-cleave-component';
import 'cleave.js/dist/addons/cleave-phone.us';
import {
  LMap, LTileLayer, LMarker, LPopup,
} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    ToastificationContent,
    BImg,
    BFormFile,
    BOverlay,
    vSelect,
    Cleave,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      alias: '',
      id: '',
      nome: '',
      grupo_id: '',
      descricao: '',
      maxChar: 65535,
      loading: false,
      imageUp: [],
      grupoName: [],
      cidade: '',
      estado_id: '',
      estadoName: [],
      regiao_id: '',
      regiaoName: [],
      endereco: '',
      cep: '',
      complemento: '',
      options: {
        cep: {
          numericOnly: true,
          delimiter: '-',
          blocks: [5, 3]
        },
        cnpj: {
          numericOnly: true,
          delimiters: ['.', '.', '/', '-'],
          blocks: [2, 3, 3, 4, 2]
        },
      },
      site: '',
      email: '',
      telefone: '',
      cnpj: '',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 8,
      center: [0, 0],
      markerLatLng: [0, 0],
      latitude: '',
      longitude: '',
      cooperativaName: [
        {"value":0,"text":"Não"},
        {"value":1,"text":"Sim"}
      ],
      cooperativa: '',
      activeIndex: 3
    }
  },
  computed:{
    ...mapGetters([
      'selectLoading',
    ])
  },
  methods: {
    submittedSize(){
      this.$refs.mymap.mapObject.invalidateSize();
    },
    changeLocation(){
      if(this.latitude && this.longitude){
        this.center = [this.latitude, this.longitude];
        this.markerLatLng = [this.latitude, this.longitude];
      }
    },
    async formSubmitted() {
      let params = new FormData();
      params.append('alias', this.alias);
      params.append('nome', this.nome);
      params.append('grupo_id', this.grupo_id.value);
      params.append('descricao', this.descricao);
      params.append('site', this.site);
      params.append('email', this.email);
      params.append('telefone', this.telefone);
      params.append('cnpj', this.cnpj);
      params.append('cooperativa', this.cooperativa.value);
      params.append('regiao_id', this.regiao_id.value);
      params.append('estado_id', this.estado_id.value);
      params.append('cidade', this.cidade);
      params.append('endereco', this.endereco);
      params.append('cep', this.cep);
      params.append('complemento', this.complemento);
      params.append('latitude', this.latitude);
      params.append('longitude', this.longitude);

      this.loading = true;
      await useJwt.request('/api/usina/edit', params).then(request => {
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: request.data.status,
            text: request.data.msg,
            icon: request.data.status == 'success' ? 'CheckCircleIcon' : 'XCircleIcon',
            variant: request.data.status == 'success' ? 'success' : 'danger',
          },
        });
      });
    },
  },
  async created() {    
    //Carrega todos os grupos
    this.loading = true;
    await useJwt.request('/api/grupo/select').then(request => {  
      this.loading = false;    
      this.grupoName = request.data;
    });

    //Carrega todos os estados
    this.loading = true;
    await useJwt.request('/api/estados/select').then(request => {      
      this.loading = false;
      this.estadoName = request.data;
    });

    //Carrega todas as regiões
    this.loading = true;
    await useJwt.request('/api/regioes/select').then(request => {    
      this.loading = false;  
      this.regiaoName = request.data;
    });
    
    //Carrega a usina selecionada
    this.loading = true;
    await useJwt.request('/api/usina-alias', {alias: this.$route.params.alias}).then(async request => {
      if(Object.keys(request.data).length > 0){
        this.loading = false;

        this.alias = request.data.alias;
        this.descricao = request.data.descricao ? request.data.descricao : '';
        this.id = request.data.id;
        this.nome = request.data.nome;
        this.grupo_id = request.data.grupo_id ? await this.grupoName.find(item => item.value == request.data.grupo_id) : '';   
        this.cidade = request.data.cidade;
        this.estado_id = request.data.estado_id ? await this.estadoName.find(item => item.value == request.data.estado_id) : '';
        this.regiao_id = request.data.regiao_id ? await this.regiaoName.find(item => item.value == request.data.regiao_id) : '';
        this.cooperativa = await this.cooperativaName.find(item => item.value == parseInt(request.data.cooperativa)); 
        this.endereco = request.data.endereco;
        this.cep = request.data.cep;
        this.complemento = request.data.complemento;
        this.site = request.data.site;
        this.email = request.data.email;
        this.telefone = request.data.telefone;
        this.cnpj = request.data.cnpj;

        const localizacao = JSON.parse(request.data.localizacao);
        if(Object.keys(localizacao).length > 0){
          if(localizacao.Latitude && localizacao.Longitude){
            this.center = [localizacao.Latitude, localizacao.Longitude];
            this.markerLatLng = [localizacao.Latitude, localizacao.Longitude];
            this.latitude = localizacao.Latitude;
            this.longitude = localizacao.Longitude;
          }
        }
      }
      else{
        this.$router.replace("/usina");
      }
    })
    .catch(() => {
      this.loading = false;
      this.$router.replace("/usina");
    });
  }
}
</script>

<style lang="scss">
.vue2leaflet-map{
  &.leaflet-container{
    height: 250px;
  }
}
</style>